import React, { useState, forwardRef } from "react";
import styled from "styled-components";

import { ProjectLinkStyled } from "./styled";
import { Button } from "../Button";

import { Modal } from "../Modal";
import { ButtonLink } from "../ButtonLink";
import { ProjectDetailCard } from "components/ProjectCard";
import { useSelector } from "react-redux";
import { PROFILE_TYPE_CONSULTANT } from "utils/constants";
import { Icon } from "assets/Icon";
import { PersonnelProjectsModal } from "./components/PersonnelProjectsModal";
import FallbackImage from "components/FallbackImage/FallbackImage";

export const Image = styled(FallbackImage)`
	align-self: center;
	width: 55px;
	height: 55px;
	border-radius: ${(props) => props.theme.radii.md};
	object-fit: ${(props) => (props.isPlaceholder ? "contain" : "cover")};
	background-color: ${(props) =>
		props.isPlaceholder ? "#e9ecf1" : "transparent"};
`;

export const ResourceLink = forwardRef((props, ref) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [projectsModalOpen, setProjectsModalOpen] = useState(false);
	let { data, isObj, reff, dragProps } = props;

	const closeModal = () => {
		setModalIsOpen(false);
	};

	const openProjectsModal = () => {
		setProjectsModalOpen(true);
	};

	const closeProjectsModal = () => {
		setProjectsModalOpen(false);
	};

	data = isObj ? data?.[1] : data;
	const profileTypeId = useSelector(
		(state) => state?.search.activeCompany?.profile_type?.id
	);

	// Combine refs if both are present
	const finalRef = reff || ref;

	return (
		<ProjectLinkStyled
			className={`project-link ${props.className}`}
			ref={finalRef}
			{...(dragProps || {})}
		>
			<div className="project-link__cell project-link__cell--img">
				<Image
					src={data?.avatar_location}
					className="project-link__img"
					isPlaceholder={!data?.avatar_location}
					alt=""
				/>
			</div>

			<div className="project-link__cell project-link__cell--title">
				<div className="project-link__cell-inner">
					<h4 className="project-link__title">{`${data?.first_name || "-"} ${
						data?.last_name || "-"
					}`}</h4>
				</div>
			</div>

			<div className="project-link__cell project-link__cell--spec">
				<div className="project-link__cell-inner">
					<p>{data?.position}</p>
				</div>
			</div>

			<div className="project-link__cell project-link__cell--spec">
				<div className="project-link__cell-inner">
					<p>{data?.experience} years</p>
				</div>
			</div>

			<div className="project-link__cell project-link__cell--spec">
				<div className="project-link__cell-inner">
					{data?.sectors && data.sectors.length ? (
						<>
							{data.sectors.map((sector) => (
								<p key={sector.id}>{sector.name}</p>
							))}
						</>
					) : (
						""
					)}
				</div>
			</div>
			{profileTypeId === PROFILE_TYPE_CONSULTANT ? (
				<>
					<div className="project-link__cell project-link__cell--spec">
						<div className="project-link__cell-inner">
							{data.disciplines?.map((discipline, index) => (
								<p key={`${discipline.id}-${discipline.name}`}>
									{discipline.name}
									{index < data.disciplines.length - 1 ? ", " : ""}
								</p>
							))}
						</div>
					</div>
					<div className="project-link__cell project-link__cell--spec">
						<div className="project-link__cell-inner">
							{data.projects_completed && data.projects_completed.length > 0 ? (
								<button
									className="flex w-fit items-center gap-1 rounded-md border border-border-primary px-2 py-1 text-xs font-medium text-secondary-700 hover:bg-gray-utility-100"
									onClick={openProjectsModal}
								>
									projects
									<Icon
										icon="arrow-up-right"
										className="text-fq-quinary-400"
									/>
								</button>
							) : null}
						</div>
					</div>
				</>
			) : null}
			<div className="project-link__cell project-link__btn-cell">
				{props.edit ? (
					<ButtonLink
						id={data?.first_name}
						to={`./edit-resource/${data?.id}`}
						btnType="secondary"
						size="sm"
						className="project-link__btn"
					>
						Edit
					</ButtonLink>
				) : (
					data?.resume &&
					data?.resume.length > 0 && (
						<Button
							as="a"
							href={
								data.resume.find((file) => file.is_default === true)
									?.file_path || data.resume[0]?.file_path
							}
							target="_blank"
							btntype="secondary"
							size="sm"
							className="project-link__btn"
						>
							Resume
						</Button>
					)
				)}
			</div>

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				shouldCloseOnOverlayClick
			>
				<ProjectDetailCard />
			</Modal>

			{/* Personnel Projects Modal */}
			{projectsModalOpen && (
				<PersonnelProjectsModal
					isOpen={projectsModalOpen}
					onClose={closeProjectsModal}
					projects={data.projects_completed || []}
					personnelId={data?.id}
					personnelName={`${data?.first_name || ""} ${data?.last_name || ""}`}
				/>
			)}
		</ProjectLinkStyled>
	);
});
